// extracted by mini-css-extract-plugin
export default {"title":"applications-components-common-ProductMaterial-material-module__title","text":"applications-components-common-ProductMaterial-material-module__text","images":"applications-components-common-ProductMaterial-material-module__images","root":"applications-components-common-ProductMaterial-material-module__root"};
    if(module.hot) {
      // 1791528100512
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  